import { render, staticRenderFns } from "./Else_Record.vue?vue&type=template&id=20cc9f97&"
import script from "./Else_Record.vue?vue&type=script&lang=js&"
export * from "./Else_Record.vue?vue&type=script&lang=js&"
import style0 from "./Else_Record.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports